import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@mui/material";
import { dataAmigavel } from "../util/General";
import { useState } from "react";
import useImageCache from "../hooks/useImageCache";
import { Delete } from "@mui/icons-material";

export default function CardAnalise({
    analise,
    handleExcluirAnalise
}) {

    const isMotion = analise.panel && analise.panel.includes('Motion');
    const link = isMotion ? `/motion/${analise.uid}` : `/analisar/${analise.uid}`;
    const [openExcluirAnalise, setOpenExcluirAnalise] = useState(false);
    
    const coverSrc = useImageCache(analise.capa);

    return (
        <Card elevation={6} sx={{ position: 'relative' }}>
            <Box sx={{ position: 'absolute', bottom: 12, right: 8, zIndex: 1 }}>
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation(); // Evita abrir o link
                        e.preventDefault();
                        setOpenExcluirAnalise(true);
                    }}
                >
                    <Delete fontSize="small" />
                </IconButton>
            </Box>

            <CardActionArea href={link} >
                <CardMedia
                    component="img"
                    height="194"
                    image={coverSrc}
                    loading="lazy"
                    onError={(e) => {
                        if (e.target.src !== '/images/capa-template.jpg') {
                            e.target.onerror = null;
                            e.target.src = '/images/capa-template.jpg';
                        }
                    }}
                />
                <CardContent>
                    <Typography gutterBottom variant="h6">
                        {analise.title}
                    </Typography>
                    <Typography color="text.secondary">
                        {analise.panel}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {dataAmigavel(analise.lastUpdate)}
                    </Typography>
                </CardContent>
            </CardActionArea>

            <Dialog open={openExcluirAnalise} onClose={() => { setOpenExcluirAnalise(false) }}>
                <DialogTitle>Deseja excluir a análise "{analise.title}"?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Essa ação não poderá ser desfeita. O vídeo da partida não será excluído.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpenExcluirAnalise(false) }}>Cancelar</Button>
                    <Button onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleExcluirAnalise(analise.uid);
                        setOpenExcluirAnalise(false);
                    }} variant="outlined">Excluir</Button>
                </DialogActions>
            </Dialog>

        </Card>
    );

}